export default __webpack_public_path__ + "static/media/fruitsVegetables.f840034c.svg";